/**
 * Authentication service for communicating with the backend API.
 */

import { request } from './api';

export const authService = {
  /**
     * Login a user.
     */
  async login(payload) {
    return request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  /**
     * Validate a stored session token and return the bound identity and role.
     */
  async me(token) {
    return request('/api/auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  /**
     * Register a new user.
     */
  async register(payload) {
    return request('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
